<div class="status-popup-container flex col border-radius-15 p-0">
  <!-- Close button - only show if not confirmation or explicitly enabled -->
  <div class="popup-header" *ngIf="showCloseButton && !isConfirmation">
    <button
      class="close-button flex items-center justify-center cursor-pointer p-0"
      mat-icon-button
      (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="popup-content flex col items-center justify-center fill-space">
    <div class="icon-container flex items-center justify-center" [ngClass]="type + '-icon'">
      <mat-icon>{{ iconName }}</mat-icon>
    </div>

    <h2 class="popup-title bold font-16 m-0">{{ title }}</h2>

    <!-- Confirmation buttons - only show in confirmation mode -->
    <div class="popup-actions flex justify-center full-width" *ngIf="isConfirmation">
      <button
        class="confirm-button border-radius-8 bold-600 font-14 mr-10"
        mat-raised-button
        (click)="onConfirm()">
        {{ confirmText }}
      </button>
      <button class="cancel-button border-radius-8 bold-600 font-14" mat-button (click)="onCancel()">
        {{ cancelText }}
      </button>
    </div>
  </div>
</div>
